import $ from 'jquery';

const initVideo = (el) => {
  const root = $(el);
  const video = root.find('video');
  const controls = root.find('.video__controls');
  const soundControls = root.find('.video__controls--sound');
  const playBtn = root.find('.btn[data-action="video-play"]');
  const pauseBtn = root.find('.btn[data-action="video-pause"]');

  const muteBtn = root.find('.btn[data-action="sound-off"]');
  const unmuteBtn = root.find('.btn[data-action="sound-on"]');

  const poster = root.find('.video__poster');
  const embedded = root.find('.video-embedded');

  const parent = root.parents();
  const videoHTML = $(video).get(0);

  const setHeight = (videoEl, vH, pH) => {
    if (pH > 0) {
      videoEl.attr('height', `${pH - 1}px`);
    } else {
      videoEl.attr('height', `${vH}px`);
    }
  };

  const resetSound = (hide = false) => {
    muteBtn.show().removeClass('active');
    video.prop('muted', false);
    if (hide) {
      soundControls.addClass('hidden');
    }
  };

  if (videoHTML) {
    muteBtn.on('click', () => {
      setTimeout(() => {
        $(muteBtn).hide().removeClass('active');
      }, 300);

      video.prop('muted', true);
    });

    unmuteBtn.on('click', () => {
      setTimeout(() => {
        $(muteBtn).show();
      }, 300);

      video.prop('muted', false);
    });

    const changeControlState = () => {
      if (videoHTML.played) {
        setTimeout(() => {
          $(playBtn).hide().removeClass('active');
        }, 100);
        root.addClass('playing');

        if (controls.hasClass('hidden')) {
          controls.removeClass('hidden');
        }
      }
      if (videoHTML.paused || videoHTML.ended) {
        setTimeout(() => {
          $(playBtn).fadeIn();
        }, 100);
        root.removeClass('playing');
      }

      if (videoHTML.ended) {
        if (soundControls.length) {
          resetSound();
        }
      }

      if (poster.length > 0 && videoHTML.ended) {
        if (poster.length > 0) {
          poster.fadeIn();
        }

        if (videoHTML.ended) {
          if (soundControls.length) {
            resetSound(true);
          }
        }
      }
    };

    $(playBtn).on('click', () => {
      if (poster.length > 0) {
        poster.fadeOut();

        if (soundControls.length) {
          if (soundControls.length) {
            resetSound(true);
          }
        }
      }
      videoHTML.play();
    });

    $(pauseBtn).on('click', () => {
      videoHTML.pause();
    });

    videoHTML.addEventListener('play', () => changeControlState(), false);
    videoHTML.addEventListener('pause', () => changeControlState(), false);
  } else if (poster.length > 0) {
    $(playBtn).on('click', () => {
      poster.fadeOut();
      root.addClass('playing');
    });

    $(pauseBtn).on('click', () => {
      poster.fadeIn();
      root.removeClass('playing');
    });
  }

  if (embedded.length > 0) {
    root.addClass('has-embedded-video');
    let rootHeight = root.outerHeight();
    let calcWidth = (rootHeight / 9) * 16;

    if (!root.hasClass('wysiwyg') && poster.length === 0) {
      controls.hide();
    }

    const iframe = embedded.find('iframe');
    if (iframe.length > 0) {
      iframe.attr('width', '100%');

      const videoHeight = (iframe.outerWidth() / 16) * 9;
      const posterHeight = poster.length > 0 ? poster.find('img').outerHeight() : 0;
      if (!root.hasClass('video-center-control--gallery')) {
        setHeight(iframe, videoHeight, posterHeight);
      } else {
        setHeight(iframe, rootHeight, rootHeight);
        iframe.attr('width', `${calcWidth}px`);
      }
    }

    $(window).on('resize', () => {
      const videoH = (iframe.outerWidth() / 16) * 9;
      const posterH = poster.length > 0 ? poster.find('img').outerHeight() : 0;
      rootHeight = root.outerHeight();
      calcWidth = (rootHeight / 9) * 16;

      if (!root.hasClass('video-center-control--gallery')) {
        setHeight(iframe, videoH, posterH);
      } else {
        setHeight(iframe, rootHeight, rootHeight);
        iframe.attr('width', `${calcWidth}px`);
      }
    });
  }

  // autoplay video in production hero, landing page, theater, artist
  if (parent.hasClass('hero-video-autoplay')) {
    playBtn.trigger('click');
  }

  if (parent.hasClass('article')) {
    controls.removeClass('hidden');
  }

  if (parent.hasClass('simple-card__image') || parent.hasClass('teaser__image')) {
    controls.remove();
  }
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstVideo = {
    attach(context) {
      $('.video, .wysiwyg', context).each((index, element) => initVideo(element));
    },
  };
}(window, Drupal));

export default initVideo;
